module.exports = __webpack_public_path__ + "static/img/symptoms2-01.d9c9961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/symptoms2-01.jpg
// module id = 293
// module chunks = 1